import React, { FC, useState } from 'react';
import { styled } from 'styled-components';
import { IPosts } from '../../../store/reducers/AllPosts';
import BlockText from '../../../UI/BlockText/BlockText';

import Img from '../../../UI/IMG/Img';
import Text from '../../../UI/Text/Text';
import InteractivePanel from './Post/InteractivePanel';
import { BeautifulNumbers } from '../../../helpers/BeautifulNumbers';

interface IPost {
  img: string;
  title: string;
  price: number;
  post: IPosts;
}

const Wrapper = styled.div`
	width: fit-content;
	height: fit-content;
	margin: 0px 20px 20px 0px;
`;

const Row = styled.div`
	width: fit-content;
	height: fit-content;
	display: flex;
`;

const Posts = styled.div``;

const BlockImg = styled(BlockText)`
	border-radius: 4px;
	display: flex;
	flex-direction: column;
`;

const StyledImg = styled(Img)`
	z-index: 0;
`;

const Post: FC<IPost> = ({ img, title, price, post }) => {
  const [focus, setFocus] = useState(false);

  const onMouseEnterFocus = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setFocus(true);
  };

  const onMouseLeaveFocus = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setFocus(false);
  };

  return (
    <Wrapper>
      <Row>
        <Posts>
          <BlockImg
            width='280px'
            height='293px'
            position='relative'
            onMouseEnter={onMouseEnterFocus}
            onMouseLeave={onMouseLeaveFocus}
          >
            <StyledImg
              width='max-content'
              height='max-content'
              src={img}
              alt='Кроссовки'
            />
            {focus === true ? <InteractivePanel post={post} /> : ''}
          </BlockImg>
          <BlockText
            width='fit-content'
            height='fit-content'
            flex_direction='column'
          >
            <Text
              fontFamily='Intro-Book'
              fontSize='16px'
              color='#444B58'
              margin='10px 0px 0px 0px'
            >
              {title}
            </Text>
            <Text
              fontFamily='Intro-Regular'
              fontSize='20px'
              color='#444B58'
              margin='10px 0px 0px 0px'
            >
              {`${BeautifulNumbers(Math.floor(price))} р`}
            </Text>
          </BlockText>
        </Posts>
      </Row>
    </Wrapper>
  );
};

export default Post;
